module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.item) ? _c('div', {
    staticClass: "component-backoffice-wallet-record"
  }, [(_vm.$is('listing')) ? _c('div', {
    staticClass: "component-card"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("ID")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v("WR" + _vm._s(_vm.item.id))])]), _c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Type & Id")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm._f("walletableType")(_vm.item.walletable_type))), _c('br'), _c('span', [_vm._v(_vm._s(_vm.item.walletable_id))])])]), _c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Tax " + _vm._s(-_vm.item.tax * 100) + "%")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.$priceWithcurrency(parseFloat(_vm.item.amount * _vm.item.tax).toFixed(2))))])]), _c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Amount")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.$priceWithcurrency(-_vm.item.amount)))])]), _c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Invoice")]), _c('div', {
    staticClass: "field-value h3 mb-0"
  }, [_vm._v(_vm._s(_vm.commercialDocumentType) + _vm._s(_vm.item.invoice.internal_id) + "(" + _vm._s(_vm.item.invoice.id) + ")")])])])]) : _vm._e(), (_vm.$is('multi-wallet')) ? _c('div', {
    staticClass: "component-card"
  }, [_c('div', {
    staticClass: "row pb-0"
  }, [_c('div', {
    staticClass: "column expand"
  }, [_c('h3', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.walletableType) + " " + _vm._s(_vm.item.walletable_id))]), _c('div', {
    staticClass: "fields"
  }, [_c('small', [_vm._v("WR" + _vm._s(_vm.item.id))])])]), _c('div', {
    staticClass: "column large-2"
  }, [_c('div', {
    staticClass: "field-content"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Created")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.created, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))]), (_vm.item.invoice_after !== null) ? _c('div', {
    staticClass: "invoice-after"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Invoice on")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.invoice_after, _vm.$toMomentFormat(_vm.configuration.locale.locale_date_format.value))))])]) : _vm._e()])])]), _c('div', {
    staticClass: "row pt-0 pb-0"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Description")]), _vm._l((_vm.item.reason.split('|')), function(reason) {
    return _c('div', [(reason.startsWith('---')) ? _c('hr', {
      staticStyle: {
        "border-style": "dotted",
        "margin": "0.5em"
      }
    }) : (reason.startsWith('- ')) ? _c('strong', [_vm._v(_vm._s(_vm.cleanString(reason, "- ")))]) : (reason.startsWith('>>')) ? _c('span', {
      staticStyle: {
        "display": "block",
        "text-indent": "1em"
      }
    }, [_vm._v(_vm._s(_vm.cleanString(reason, ">>")))]) : _c('span', [_vm._v(_vm._s(reason))])])
  })], 2)]), _c('div', {
    staticClass: "row text-center bottom"
  }, [(_vm.walletableType !== 'Invoice') ? [_c('div', {
    staticClass: "column shrink"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Vat " + _vm._s(-_vm.item.tax * 100) + "%")]), _c('h3', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.$priceWithcurrency(_vm.vat.toFixed(2))))])]), _c('div', {
    staticClass: "column shrink"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Amount")]), _c('h3', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.$priceWithcurrency(_vm.item.amount.toFixed(2))))])]), _c('div', {
    staticClass: "column shrink"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Total")]), _c('h3', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.$priceWithcurrency((_vm.item.amount + _vm.vat).toFixed(2))))])]), (_vm.item.hasOwnProperty('invoice')) ? [(_vm.item.invoice.internal_id) ? _c('div', {
    staticClass: "column shrink"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Invoice")]), _c('router-link', {
    attrs: {
      "to": {
        name: 'invoice',
        params: {
          id: _vm.item.invoice.id
        }
      }
    }
  }, [_c('h3', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.commercialDocumentType) + _vm._s(_vm.item.invoice.internal_id))])])], 1) : (!_vm.item.invoice.internal_id && _vm.item.billable) ? _c('div', {
    staticClass: "column shrink"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Invoice")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v("Not invoiced yet")])]) : _vm._e()] : _vm._e()] : [_c('div', {
    staticClass: "column shrink"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Subtotal")]), _c('h3', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s((_vm.item.amount.toFixed(2))))])]), (_vm.item.invoice.internal_id) ? _c('div', {
    staticClass: "column shrink"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Invoice")]), _c('router-link', {
    attrs: {
      "to": {
        name: 'invoice',
        params: {
          id: _vm.item.invoice.id
        }
      }
    }
  }, [_c('h3', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.commercialDocumentType) + _vm._s(_vm.item.invoice.internal_id))])])], 1) : (!_vm.item.invoice.internal_id && _vm.item.billable) ? _c('div', {
    staticClass: "column shrink"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Invoice")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v("Not invoiced yet")])]) : _vm._e()]], 2)]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3b59c721!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/WalletRecord.vue
// module id = 2424
// module chunks = 1